module.exports = __webpack_public_path__ + "img/profitable-img-6.250cf398.png";